import React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { DownloadSimple } from "@phosphor-icons/react";
import { designImg, designDxf, fmtDate } from "./designsApi";
import { CategoryEditor } from "./CategoryEditor";

const Row = ({ k, v, id }) => (
  <div className="flex justify-between gap-3 text-sm border-b border-slate-800 py-1.5">
    <span className="text-slate-400">{k}</span>
    <span className="text-slate-100 text-right break-all" data-testid={id}>{v || "—"}</span>
  </div>
);

export const DesignDetailDialog = ({ d, onClose, onSaved }) => (
  <Dialog open={!!d} onOpenChange={(o) => !o && onClose()}>
    <DialogContent className="max-w-5xl w-[96vw] max-h-[92vh] overflow-y-auto rounded-sm bg-slate-950 border-slate-800" data-testid="design-detail-dialog">
      {d && (
        <>
          <DialogHeader>
            <DialogTitle className="font-mono-num pr-8 break-words">
              <span className="text-orange-400 text-2xl font-black mr-2" data-testid="design-detail-serial">{d.serial_label || "D-…"}</span>
              #{d.order_number} · {d.customer_name}
            </DialogTitle>
          </DialogHeader>
          <div className="grid md:grid-cols-3 gap-4">
            <div className="md:col-span-2 bg-white rounded-sm flex items-center justify-center p-2">
              <img src={designImg(d.id, false, d.rendered_at)} alt="design" className="max-w-full max-h-[70vh] object-contain" data-testid="design-detail-image" />
            </div>
            <div className="space-y-3">
              <div>
                <Row k="Design no." v={d.serial_label || "number aa raha hai"} />
                <Row k="Order" v={`#${d.order_number}`} id="design-detail-order" />
                <Row k="Customer" v={d.customer_name} id="design-detail-customer" />
                <Row k="Size (W x H)" v={d.plate_size} id="design-detail-size" />
                <Row k="Sheet" v={d.sheet_type} />
                <Row k="Upload date" v={fmtDate(d.file_uploaded_at || d.order_date)} />
                <Row k="File" v={d.original_filename} id="design-detail-filename" />
                <Row k="Shapes" v={d.meta?.closed_loops} />
              </div>
              <Button asChild className="w-full rounded-sm bg-orange-500 hover:bg-orange-600 text-white" data-testid="design-download-dxf">
                <a href={designDxf(d.id)} download={d.original_filename || `${d.order_number}.dxf`}>
                  <DownloadSimple size={16} className="mr-2" /> ORIGINAL DXF DOWNLOAD
                </a>
              </Button>
              <div className="text-[11px] text-slate-500">Original file kabhi change nahi hoti — wahi file milegi jo upload hui thi.</div>
              <CategoryEditor d={d} onSaved={onSaved} />
            </div>
          </div>
        </>
      )}
    </DialogContent>
  </Dialog>
);
